import { useNavigate, useRouter } from "@tanstack/react-router";
import { LogOut } from "lucide-react"; // Importing the Menu icon from Lucide
import { SidebarMenuButton } from "./ui/sidebar";
import { useAuth } from "@/auth/AuthProvider";
import { ConfirmDialog } from "@/components/ConfirmDialog";

export function LogoutButton() {
  const auth = useAuth();
  const router = useRouter();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await auth.logout();
      await router.invalidate();
      return navigate({ to: "/login" });
    } catch (error) {
      console.error("Error during logout:", error);
      return navigate({ to: "/login" });
    }
  };

  return (
    <ConfirmDialog
      onConfirm={handleLogout}
      title="Are you sure you want to logout?"
      description="You will need to login again to access your account."
      confirmText="Log out"
    >
      <SidebarMenuButton tooltip="Log out">
        <LogOut />
        <span>Log out</span>
      </SidebarMenuButton>
    </ConfirmDialog>
  );
}
